// src/i18n/translations/fr.js

export default {
  // Éléments généraux et actions
  common: {
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    loading: 'Chargement',
    success: 'Succès',
    error: 'Erreur',
    confirm: 'Confirmer',
    warning: 'Avertissement',
    info: 'Info',
    close: 'Fermer',
    cancel: 'Annuler',
    changeLanguage: 'Changer de langue',
    changingLanguage: 'Changement de langue...',
    languageInfoDescription: 'Les changements de langue sont appliqués instantanément et reflétés dans tout le contenu. Votre préférence est automatiquement enregistrée.',
    quickAccess: 'Accès Rapide',
    closeMenu: 'Fermer le menu',
    tools: 'Outils',
    me: 'Moi',
    add: 'Ajouter',
    copy: 'Copier',
    copyLink: 'Copier le lien',
    share: 'Partager',
    copyFailed: 'Échec de la copie:',
    name: 'Nom',
    user: 'Utilisateur',
    continue: 'Continuer',
    processing: 'Traitement en cours...',
    change: 'Changer',
    copied: 'Copié',
    understand: 'Je comprends',
    ok: 'OK',
    back: 'Retour',
    backToDashboard: 'Retour au Tableau de Bord',
    digitalDiscipline: 'Discipline Numérique'
  },

  // Slogans
  slogan: {
    decentralized: "La première solution d'identité décentralisée au monde",
    evolution: "La prochaine étape dans l'évolution de l'identité",
    control: "Reprenez le contrôle de vos données",
    secure: "La forteresse sécurisée de votre identité numérique"
  },

  // Paramètres
  settings: {
    title: 'Paramètres'
  },

  // Navigation et éléments de menu
  nav: {
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    digitalVault: 'Coffre-fort numérique',
    settings: 'Paramètres',
    twoFA: 'Authentification à deux facteurs',
    qrCode: 'Code QR',
    logout: 'Déconnexion',
    gameHub: 'Centre de jeux',
    messages: 'Messages',
    qr: 'Code QR',
    notifications: 'Notifications',
    vault: 'Coffre-fort numérique'
  },

  // Écran d'accueil
  welcome: {
    title: 'Première identité décentralisée au monde',
    subtitle: 'Rejoignez IDapps et entrez dans le nouveau monde',
    loginButton: 'Se connecter',
    signupButton: 'Créer un compte',
    footer: {
      description: 'Plateforme d\'identité décentralisée basée sur la blockchain',
      version: 'v1.0.1 © 2023-2025 IDapps'
    },
    welcomeTitle: 'Bienvenue',
    heroTitle: 'Votre Identité,\nRéinventée.',
    getStarted: 'Commencer',
    haveAccount: 'Vous avez déjà un compte ?',
    login: 'Se connecter',
    signInWithApple: 'Se connecter avec Apple'
  },

  // Écran de connexion et authentification
  login: {
    title: 'Première identité décentralisée au monde',
    subtitle: 'Connectez-vous pour accéder à votre coffre-fort numérique',
    usernameInput: 'Nom d\'utilisateur ou email',
    formError: {
      emptyFields: 'Veuillez saisir le nom d\'utilisateur et le mot de passe.',
      default: 'Échec de la connexion. Veuillez vérifier votre nom d\'utilisateur et votre mot de passe.',
      demoFailed: 'Échec de la connexion de démonstration.'
    },
    loggingIn: 'Connexion en cours...',
    loginButton: 'Se connecter',
    demoLoginDone: 'Connexion de démonstration effectuée',
    demoLogin: 'Connexion de démonstration (Développeur)',
    forgotPassword: 'Mot de passe oublié',
    noAccount: 'Vous n\'avez pas encore de compte IDapps?',
    createAccount: 'Créer un compte',
    loginTitle: 'Connexion',
    welcomeBack: 'Bon retour',
    username: 'Nom d\'utilisateur',
    email: 'E-mail',
    password: 'Mot de passe',
    forgot: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    processing: 'Traitement...',
    create: 'Créer une identité',
    error: {
      empty: 'Veuillez remplir tous les champs',
      failed: 'Échec de la connexion. Vérifiez vos identifiants.'
    }
  },

  // Écran d'inscription
  signup: {
    title: 'Première identité décentralisée au monde',
    subtitle: 'Rejoignez IDapps et entrez dans le nouveau monde',
    createIdappsAccount: 'Créer un compte IDapps',
    createAccountWithApple: 'CRÉER UN COMPTE AVEC APPLE',
    createAccountWithFacebook: 'CRÉER UN COMPTE AVEC FACEBOOK',
    alreadyHaveAccount: 'Vous avez déjà un compte IDapps?',
    signupTitle: 'Inscription',
    confirmPassword: 'Confirmer le mot de passe',
    phoneNumber: 'Numéro de téléphone',
    verificationCode: 'Code de vérification',
    continueButton: 'Continuer',

    // New Signup Flow Keys
    nameTitle: "Quel est votre nom ?",
    nameSubtitle: "Ceci sera affiché sur votre profil",
    namePlaceholder: "Votre nom complet",

    emailTitle: "Quelle est votre adresse e-mail ?",
    emailSubtitle: "Nous l'utiliserons pour la vérification du compte",
    emailPlaceholder: "nom@exemple.com",

    passwordTitle: "Créez un mot de passe",
    passwordSubtitle: "Rendez-le fort et unique",
    passwordPlaceholder: "Minimum 8 caractères",

    confirmTitle: "Confirmer les détails",
    confirmSubtitle: "Assurez-vous que tout est correct",

    complete: "Créer le compte",
    haveAccount: "Vous avez déjà un compte ?",
    login: "Se connecter",

    error: {
      nameRequired: "Le nom est requis",
      emailRequired: "L'e-mail est requis",
      emailInvalid: "Adresse e-mail invalide",
      passwordLength: "Le mot de passe doit contenir au moins 8 caractères",
      generic: "Échec de l'inscription. Veuillez réessayer.",
      empty: 'Veuillez remplir tous les champs'
    }
  },

  // Section profil
  profile: {
    personalInfo: 'Informations personnelles',
    bloodType: 'Groupe sanguin',
    height: 'Taille',
    weight: 'Poids',
    heightWeight: 'Taille / Poids',
    languages: 'Langues',
    contacts: 'Contacts',
    bio: 'À propos de moi',
    editProfile: 'Modifier le profil',
    identity: 'Identité',
    profileTitle: 'Profil',
    qrId: 'Mon ID QR',
    tattoo: 'Tatouage',
    shareProfileQR: 'Montrez ce code QR pour partager votre profil',
    profileLinkCopied: 'Lien de partage du profil copié',
    shareProfileDescription: 'Vous pouvez utiliser ce code QR pour partager le profil de {name}'
  },

  // Sécurité et authentification
  security: {
    security: 'Sécurité',
    securityStatus: 'Statut de sécurité',
    accountSecure: 'Votre compte est sécurisé',
    securityMeasuresActive: 'Toutes les mesures de sécurité sont actives.',
    twoFactorAuth: 'Authentification à deux facteurs',
    active: 'Actif',
    passwordStrength: 'Force du mot de passe',
    strong: 'Fort',
    lastLogin: 'Dernière connexion',
    today: 'Aujourd\'hui',
    manageSecuritySettings: 'Gérer les paramètres de sécurité',
    blockchainSecurity: 'Sécurité blockchain',
    blockchainSecurityDesc: 'Votre compte est protégé avec une sécurité supplémentaire via la connexion au portefeuille blockchain.',
    connectedWallet: 'Portefeuille connecté',
    securityVerification: 'Vérification de sécurité',
    biometricAuth: 'Authentification biométrique',
    setupTwoFA: 'Configuration 2FA',
    scanQRCode: 'Scanner le code QR',
    enterCode: 'Saisir le code',
    recoveryKey: 'Clé de récupération',
    backupCodes: 'Codes de secours',
    passwordAndSecurity: 'Mot de passe et sécurité',
    emailAndContact: 'Email et contact',
    twoFactorAuthTitle: 'Authentification à deux facteurs',
    securitySettings: 'Paramètres de sécurité',
    endToEndEncryption: 'Chiffrement de bout en bout',
    enhancedSecurityMode: 'Mode de sécurité renforcé actif',
    maxSecurityMode: 'Mode de sécurité maximale actif',
    endToEndEncryptionAccess: 'Accès sécurisé avec chiffrement de bout en bout',
    secure: 'Sécurisé',
    customQR: 'QR personnalisé',
    customQRCodes: 'Codes QR personnalisés',
    customQRDescription: 'Créez des codes QR personnalisés pour vos liens fréquemment utilisés et partagez-les rapidement.',
    noCustomQR: 'Vous n\'avez pas encore de codes QR personnalisés.',
    linkName: 'Nom du lien',
    addNewQRCode: 'Ajouter un nouveau code QR',

    // Section d'authentification à deux facteurs
    twoFA: {
      // Onglets
      tabs: {
        setup: 'Configuration',
        codes: 'Codes',
        backup: 'Sauvegarde',
        devices: 'Appareils'
      },

      // Messages d'état
      status: {
        enabled: '2FA activé',
        disabled: '2FA non activé'
      },

      // Messages d'erreur
      errors: {
        walletRequired: 'Vous devez d\'abord connecter votre portefeuille blockchain pour configurer la 2FA.',
        setupFailed: 'Une erreur s\'est produite pendant la configuration. Veuillez réessayer.',
        invalidCode: 'Veuillez saisir le code de vérification à 6 chiffres.',
        verificationFailed: 'Code de vérification invalide. Veuillez réessayer.',
        generalError: 'Une erreur s\'est produite. Veuillez réessayer.',
        codeRequired: 'Veuillez saisir le code de vérification de sécurité.',
        disableFailed: 'Impossible de désactiver la 2FA. Le code peut être incorrect.',
        passwordTooShort: 'Veuillez saisir un mot de passe d\'au moins 8 caractères.',
        exportFailed: 'Impossible d\'exporter les données 2FA.',
        noImportData: 'Veuillez saisir les données 2FA à importer.',
        passwordRequired: 'Veuillez saisir votre mot de passe.',
        importFailed: 'Impossible d\'importer les données 2FA. Le mot de passe peut être incorrect.',
        deviceRemoveFailed: 'Impossible de supprimer l\'appareil.'
      },

      // Messages de succès
      success: {
        verified: 'Vérification réussie! 2FA activée.',
        disabled: '2FA désactivée avec succès.',
        exported: 'Données 2FA exportées avec succès.',
        imported: 'Données 2FA importées avec succès.',
        deviceRemoved: 'Appareil supprimé avec succès.',
        deviceVerified: 'Appareil vérifié avec succès.',
        enabled: '2FA activée!',
        enabledDescription: 'L\'authentification à deux facteurs a été activée avec succès. Votre compte est maintenant plus sécurisé.'
      },

      // Étiquettes générales et descriptions
      decentralized: '2FA décentralisée',
      description: 'L\'authentification à deux facteurs (2FA) ajoute une couche de sécurité supplémentaire à votre compte. Cette fonctionnalité garantit que votre compte est protégé même si votre mot de passe est compromis.',
      scanQRCode: 'Scanner le code QR',
      scanQRDescription: 'Scannez le code QR ci-dessous à l\'aide de Google Authenticator, Authy ou une application d\'authentification similaire.',
      manualKeyInstructions: 'Si vous ne pouvez pas scanner le code QR, vous pouvez saisir manuellement cette clé:',
      verificationCode: 'Code de vérification',
      enterSixDigitCode: 'Saisissez le code à 6 chiffres',
      disableInstructions: 'L\'authentification à deux facteurs est actuellement activée. Pour désactiver cette fonctionnalité, saisissez un code de vérification de votre application d\'authentification.',
      currentCode: 'Code actuel',
      codeRefreshTime: 'Actualisation dans {seconds} secondes',
      codeRefreshing: 'Actualisation...',
      backupCodes: 'Codes de secours',
      backupCodesInstructions: 'Vous pouvez utiliser ces codes de secours lorsque vous n\'avez pas accès à votre appareil 2FA. Chaque code ne peut être utilisé qu\'une seule fois.',
      backupCodesDescription: 'Conservez ces codes de secours dans un endroit sûr. Vous pouvez les utiliser lorsque vous n\'avez pas accès à votre application d\'authentification.',
      saveBackupCodes: 'Enregistrer les codes de secours',
      blockchainVerification: 'Vérification blockchain',
      blockchainVerificationDescription: 'Vos preuves de vérification 2FA sont stockées et vérifiées en toute sécurité sur la blockchain.',
      lastVerification: 'Dernière vérification',
      timeAgo: 'il y a {time} heures',
      verifiedOnPolygon: 'Vérifié sur le réseau Polygon',
      proofGenerated: 'Preuve de vérification générée: {proof}...',
      enableFirstToViewCodes: 'Vous devez d\'abord activer la 2FA pour voir les codes de vérification.',
      backupAndRecovery: 'Sauvegarde et récupération',
      backupDescription: 'Vous pouvez exporter vos données 2FA (chiffrées) ou importer des données précédemment sauvegardées.',
      exportData: 'Exporter les données',
      exportDescription: 'Exportez vos données 2FA chiffrées avec un mot de passe fort. Stockez ce fichier dans un endroit sécurisé.',
      password: 'Mot de passe',
      passwordPlaceholder: 'Saisissez votre mot de passe (au moins 8 caractères)',
      encryptedData: 'Données chiffrées',
      storeDataSafely: 'Stockez ces données en toute sécurité. Si vous oubliez votre mot de passe, vous ne pourrez pas récupérer les données.',
      importData: 'Importer les données',
      importDescription: 'Importez les données 2FA que vous avez précédemment exportées. Cela modifiera vos paramètres 2FA actuels.',
      pasteEncryptedData: 'Collez les données chiffrées exportées',
      enterPassword: 'Saisissez votre mot de passe',
      arweaveBackup: 'Sauvegarde Arweave',
      arweaveDescription: 'Vos preuves de vérification 2FA sont stockées chiffrées sur Arweave. Cela fournit une sauvegarde permanente et immuable.',
      arweaveBackupStarted: 'Processus de sauvegarde Arweave démarré. Cela peut prendre quelques minutes.',
      decentralizedStorage: 'Stockage décentralisé',
      arweaveTokenRequired: 'Arweave assure un stockage permanent et immuable de vos données. Une petite quantité de jetons AR est nécessaire pour le processus de sauvegarde.',
      verifiedDevices: 'Appareils vérifiés',
      devicesDescription: 'Vous pouvez gérer vos appareils vérifiés par 2FA ici.',
      noVerifiedDevices: 'Pas encore d\'appareils vérifiés.',
      thisDevice: 'Cet appareil',
      deviceVerificationDescription: 'L\'appareil que vous utilisez est automatiquement ajouté à la liste des appareils vérifiés. Vérifiez régulièrement vos appareils et supprimez les appareils que vous ne reconnaissez pas.',
      deviceConnectionHistory: 'Historique des connexions des appareils',
      lastAccess: 'Dernier accès: {time}',
      daysAgo: 'il y a {days} jours',
      weeksAgo: 'il y a {weeks} semaines',

      // Types d'appareils
      deviceTypes: {
        mobile: 'Appareil mobile',
        desktop: 'Appareil de bureau'
      },

      // Section fonctionnalités
      features: {
        highSecurity: {
          title: 'Haute sécurité',
          description: 'Les codes d\'authentification sont générés avec une clé secrète stockée sur votre appareil.'
        },
        easyToUse: {
          title: 'Facile à utiliser',
          description: 'Vous pouvez utiliser n\'importe quelle application d\'authentification avec numérisation de code QR.'
        },
        decentralized: {
          title: 'Décentralisé',
          description: 'Les données de sécurité sont vérifiées sur la blockchain, sans dépendre des serveurs.'
        }
      },

      // Modal d'information de récupération
      recoveryInfo: {
        title: 'Informations de récupération',
        description: 'Avec les options de récupération 2FA, vous pouvez accéder à votre compte même si vous perdez votre appareil ou supprimez votre application:',
        backupCodes: {
          title: 'Codes de secours',
          description: 'Chaque code de secours est valable pour une seule utilisation. Conservez ces codes dans un endroit sûr.'
        },
        encryptedBackup: {
          title: 'Sauvegarde chiffrée',
          description: 'Vous pouvez exporter vos données 2FA sous forme chiffrée. N\'oubliez pas ce mot de passe, sinon la sauvegarde ne pourra pas être utilisée.'
        },
        verifiedDevices: {
          title: 'Appareils vérifiés',
          description: 'Vos appareils précédemment vérifiés peuvent vous aider dans le processus d\'authentification.'
        }
      },

      // Modal de suppression d'appareil
      removeDevice: {
        title: 'Supprimer l\'appareil',
        confirmation: 'Êtes-vous sûr de vouloir supprimer cet appareil?'
      },

      // Boutons
      buttons: {
        startingSetup: 'Démarrage de la configuration',
        startSetup: 'Démarrer la configuration 2FA',
        verifying: 'Vérification...',
        verify: 'Vérifier',
        disable: 'Désactiver la 2FA',
        copyCode: 'Copier le code',
        copyAll: 'Tout copier',
        generateNewCodes: 'Générer de nouveaux codes',
        generateProof: 'Générer une preuve de vérification',
        goToSetup: 'Aller à la configuration 2FA',
        export: 'Exporter',
        import: 'Importer',
        backupToArweave: 'Sauvegarder sur Arweave',
        verifyThisDevice: 'Vérifier cet appareil'
      }
    }
  },

  // Coffre-fort numérique et notes
  vault: {
    vault: 'Coffre-fort',
    notes: 'Notes',
    backups: 'Sauvegardes',
    addNote: 'Ajouter une note',
    searchNotes: 'Rechercher dans les notes',
    noteTitle: 'Titre de la note',
    noteContent: 'Contenu de la note',
    addTag: 'Ajouter une étiquette',
    saveNote: 'Enregistrer la note',
    digitalVaultTitle: 'Coffre-fort numérique',
    endlessNotesTitle: 'Notes infinies',
    memoryPalace: 'Palais de mémoire'
  },

  // Paramètres de l'application
  settings: {
    appSettings: 'Paramètres de l\'application',
    appSettingsDesc: 'Gérer le comportement et les préférences de l\'application',
    accountSettings: 'Paramètres du compte',
    accountSettingsDesc: 'Gérer vos informations de profil et vos préférences',
    languageSelection: 'Sélection de la langue',
    selectLanguageDescription: 'Sélectionnez la langue que vous souhaitez utiliser pour l\'application.',
    themeAndAppearance: 'Thème et apparence',
    notificationSettings: 'Paramètres de notification',
    languageAndRegion: 'Langue et région',
    other: 'Autre',
    helpAndSupport: 'Aide et support',
    aboutAndLegal: 'À propos et juridique',
    confirmLogout: 'Voulez-vous vous déconnecter?',
    logoutDescription: 'Vous êtes sur le point de vous déconnecter de votre compte. Vous devrez vous reconnecter.'
  },

  // Informations du compte
  account: {
    title: 'Saisir les informations du compte',
    description: 'Saisissez les informations du compte pour terminer le processus de création de compte.',
    gender: {
      male: 'Homme',
      female: 'Femme',
      other: 'Autre'
    },
    error: {
      missingFields: 'Veuillez remplir tous les champs obligatoires.',
      passwordMismatch: 'Les mots de passe ne correspondent pas.',
      passwordTooShort: 'Le mot de passe doit comporter au moins 6 caractères.'
    },
    termsAgreement: 'En créant un compte, vous acceptez les {terms} et la {privacy}.',
    termsAndConditions: 'Conditions générales',
    privacyPolicy: 'Politique de confidentialité'
  },

  // Section tableau de bord
  dashboard: {
    exhibitions: 'Expositions',
    identity: 'Identité',
    myFolders: 'Mes dossiers',
    qrIdentity: 'Identité QR',
    badges: 'Badges',
    activity: 'Activité',
    active: 'Actif',
    noItems: 'Pas encore d\'éléments dans ce dossier',
    addItem: 'Ajouter un élément',
    folders: {
      personal: 'Personnel',
      health: 'Santé',
      documents: 'Documents',
      favorite: 'Favoris'
    },
    emergencyInfo: 'Informations d\'urgence',
    allergies: 'Allergies',
    healthConditions: 'Conditions de santé',
    medications: 'Médicaments',
    emergencyContacts: 'Contacts d\'urgence',
    addEmergencyContact: 'Ajouter un contact d\'urgence',
    personalInfo: 'Informations personnelles'
  },

  // Section notifications
  notifications: {
    tabs: {
      incoming: 'Entrants',
      reminders: 'Rappels',
      tasks: 'Tâches'
    },
    markAllAsRead: 'Marquer tout comme lu',
    new: 'Nouveau',
    goToGame: 'Aller au jeu',
    noSearchResults: 'Aucun résultat de recherche trouvé',
    noNotifications: 'Pas encore de notifications',
    noReminders: 'Pas encore de rappels',
    clearSearch: 'Effacer la recherche',
    addReminder: 'Ajouter un rappel',
    loading: 'Chargement des notifications...',
    reminder: {
      new: 'Nouveau rappel',
      title: 'Titre',
      titlePlaceholder: 'Titre du rappel',
      description: 'Description',
      descriptionPlaceholder: 'Description (facultatif)',
      date: 'Date',
      time: 'Heure',
      category: 'Catégorie',
      priority: 'Priorité',
      repeat: 'Répétition',
      noRepeat: 'Pas de répétition'
    },
    categories: {
      personal: 'Personnel',
      work: 'Travail',
      health: 'Santé',
      finance: 'Finance',
      entertainment: 'Divertissement'
    },
    priorities: {
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Haute'
    },
    repeat: {
      daily: '🔄 Tous les jours',
      weekly: '🔄 Toutes les semaines',
      monthly: '🔄 Tous les mois',
      yearly: '🔄 Tous les ans'
    },
    filters: {
      all: 'Tous',
      connections: 'Connexions',
      messages: 'Messages',
      verifications: 'Vérifications',
      security: 'Sécurité',
      games: 'Jeux',
      system: 'Système',
      active: 'Actif',
      completed: 'Terminé',
      highPriority: 'Haute priorité',
      mediumPriority: 'Priorité moyenne',
      lowPriority: 'Faible priorité'
    },
    time: {
      justNow: 'À l\'instant',
      minutesAgo: 'il y a {minutes} minutes',
      hoursAgo: 'il y a {hours} heures',
      daysAgo: 'il y a {days} jours',
      today: 'Aujourd\'hui {time}',
      tomorrow: 'Demain {time}',
      futureDate: 'Le {date} à {time}',
      fullDate: '{day}/{month}/{year}'
    },
    errors: {
      loadFailed: 'Erreur lors du chargement des données de notification:'
    },
    demo: {
      connectionRequest: 'Vous a envoyé une demande de connexion',
      idappsVerification: 'Vérification IDapps',
      qrVerified: 'Votre code QR a été vérifié avec succès',
      securityCenter: 'Centre de sécurité',
      newLogin: 'Un nouvel appareil s\'est connecté à votre compte',
      system: 'Système',
      appUpdated: 'L\'application IDapps a été mise à jour, découvrez les nouvelles fonctionnalités',
      sentMessage: 'Vous a envoyé un message: "Bonjour, comment allez-vous?"',
      gameHub: 'IDapps GameHub',
      newGame: 'Nouveau jeu: Crypto Quest est en ligne! Tournoi lancé avec un prix de 50 IDCOIN.',
      connectionAccepted: 'A accepté votre demande de connexion',
      reminders: {
        weeklyMeeting: 'Réunion hebdomadaire',
        teamMeeting: 'Réunion d\'équipe - via Zoom',
        doctorAppointment: 'Rendez-vous médical',
        dentalCheckup: 'Contrôle dentaire - Hôpital dentaire de la ville',
        bills: 'Factures',
        utilityBills: 'Paiement des factures d\'électricité et d\'eau',
        birthday: 'Anniversaire',
        mothersBirthday: 'Anniversaire de maman - Acheter un cadeau',
        gameTournament: 'Tournoi GameHub',
        puzzleTournament: 'Tournoi de puzzle blockchain IDapps'
      }
    },
    tasks: {
      dailyTasks: 'Tâches quotidiennes',
      wakeUp: 'Se réveiller à 7h',
      checkEmails: 'Vérifier les emails',
      reviewProject: 'Réviser le plan du projet',
      completeGameTasks: 'Compléter les tâches quotidiennes dans IDapps GameHub',
      workSchedule: 'Programme de travail',
      projectDevelopment: 'Développement de projet',
      meetings: 'Réunions',
      codeReviews: 'Révisions de code',
      gameTournament: 'Tournoi GameHub',
      upcomingEvents: 'Événements à venir',
      blockchainMeetup: 'Meetup blockchain',
      web3Conference: 'Conférence Web3',
      onlineEvent: 'Événement en ligne',
      idappsGameTournament: 'Tournoi de jeu IDapps',
      metaverseEvent: 'Événement métaverse',
      goals: 'Objectifs',
      dailyStepGoal: 'Objectif quotidien de pas',
      waterIntake: 'Consommation d\'eau (ml)',
      workTime: 'Temps de travail',
      idcoinGoal: 'Objectif IDCOIN',
      hours: 'heures'
    }
  },

  // Blockchain et connexions de portefeuille
  blockchain: {
    connectWallet: 'Connecter le portefeuille',
    walletConnected: 'Portefeuille connecté',
    walletAddress: 'Adresse du portefeuille',
    arweaveSync: 'Synchronisation Arweave',
    backupToArweave: 'Sauvegarder sur Arweave',
    permanentStorage: 'Stockage permanent',
    walletTitle: 'Portefeuille blockchain',
    walletDescription: 'Vous pouvez connecter un portefeuille blockchain pour sécuriser votre identité décentralisée.',
    wallet: 'Portefeuille'
  },

  // Titres d'écran
  screens: {
    dashboardTitle: 'Tableau de bord',
    qrScannerTitle: 'Scanner de code QR',
    gameHubTitle: 'Centre de jeux',
    messagingTitle: 'Messagerie',
    notificationsTitle: 'Notifications',
    forgotPasswordTitle: 'Mot de passe oublié',
    chatsTab: 'Discussions',
    groupsTab: 'Groupes'
  },

  // Écran de messagerie
  messaging: {
    searchChat: 'Rechercher une discussion...',
    noSearchResults: 'Aucun résultat de recherche trouvé',
    noResultsFor: 'Aucun résultat pour "{searchQuery}"',
    noGroupChats: 'Vous n\'avez pas encore créé de discussions de groupe.',
    createNewGroup: 'Créer un nouveau groupe',
    encryptionDescription: 'Tous vos messages dans IDapps sont chiffrés de bout en bout et ne peuvent être lus que par vous et la personne avec qui vous discutez.',
    selfDestructMessages: 'Messages auto-destructeurs',
    selfDestructDescription: 'Envoyez des messages auto-destructeurs pour vos conversations privées. Ils sont automatiquement supprimés après avoir été lus.',
    activateFeature: 'Activer la fonctionnalité',
    aiAssistantPrivacy: 'Confidentialité de l\'assistant IA',
    aiPrivacyDescription: 'Votre assistant de messagerie fonctionne entièrement sur votre appareil et vos données ne sont jamais envoyées à un serveur.',
    aiAssistantActive: 'Assistant IA actif',
    aiResponseSuggestions: 'Suggestions de réponse IA',
    writeMessage: 'Écrire un message...',
    online: 'En ligne',
    lastSeen: 'Vu pour la dernière fois: Aujourd\'hui à 15:42',
    greeting: 'Salut, comment vas-tu?',
    imGood: 'Je vais bien, et toi?',
    imGoodToo: 'Je vais bien aussi, merci.',
    sentToYou: 'Je te l\'ai envoyé.',
    canYouSendFiles: 'Peux-tu envoyer les fichiers?',
    agreed: 'D\'accord.',
    projectCostQuestion: 'Bonjour, pouvons-nous discuter du coût du projet?',
    whatDoYouThink: 'Bien sûr, qu\'en penses-tu?',
    priceProposal: 'Je pense que 500€ est un prix équitable.',
    seeYou: 'D\'accord, à bientôt.',
    meetingInvite: 'Réunion demain à 15h, peux-tu y participer?',
    callMeWhenFree: 'Peux-tu m\'appeler quand tu es libre?',
    aiSuggestion1: 'Oui, je l\'ai terminé. Je vais l\'envoyer sous peu.',
    aiSuggestion2: 'J\'y travaille, ce sera prêt demain.',
    aiSuggestion3: 'Je ne l\'ai pas encore terminé, je le terminerai cette semaine.',
    aiSuggestion4: 'Bien sûr, je t\'appellerai dans 10 minutes.',
    aiSuggestion5: 'Je suis en réunion maintenant, puis-je t\'appeler dans 1 heure?',
    aiSuggestion6: 'Je ne suis pas disponible aujourd\'hui, puis-je t\'appeler demain?'
  },

  // Section GameHub
  gameHub: {
    loadingGames: 'Chargement des jeux...',
    play: 'Jouer',
    join: 'Rejoindre',
    progress: 'Progression',
    level: 'Niveau {completed}/{total}',
    rewards: 'Récompenses',
    points: 'points',
    totalPoints: 'Points totaux',
    xpProgress: 'XP: {current}/{next}',
    featuredGame: 'Jeu à la une',
    categoriesTitle: 'Catégories',
    allGames: 'Tous les jeux',
    seeAll: 'Voir tout',
    dailyLogin: 'Connexion quotidienne',
    dayStreak: 'Série de {days} jours',
    dailyLoginInfo: 'Gagnez des IDCOIN en vous connectant chaque jour. Récompense bonus lorsque vous vous connectez pendant 7 jours consécutifs!',
    completed: '{completed}/{total} Terminé',
    playerCount: '{count} Joueurs',
    coinReward: '{amount} IDCOIN de récompense',
    participants: 'Participants: {count}',
    startingGame: 'Démarrage du jeu {title}...',

    errors: {
      loadFailed: 'Erreur lors du chargement des données GameHub:'
    },

    tabs: {
      games: 'Jeux',
      daily: 'Quotidien',
      leaderboard: 'Classement',
      rewards: 'Récompenses'
    },

    categories: {
      quiz: 'Quiz',
      puzzle: 'Puzzle',
      collection: 'Collection',
      simulation: 'Simulation',
      strategy: 'Stratégie'
    },

    games: {
      cryptoQuest: {
        title: 'Crypto Quest',
        description: 'Progressez dans le monde crypto, testez vos connaissances et gagnez des IDCOIN!'
      },
      blockchainPuzzle: {
        title: 'Puzzle Blockchain',
        description: 'Résolvez des puzzles sur la blockchain, complétez des contrats intelligents!'
      },
      nftCollector: {
        title: 'Collectionneur NFT',
        description: 'Collectionnez des NFT rares, complétez votre collection et gagnez des récompenses!'
      },
      defiTrader: {
        title: 'Trader DeFi',
        description: 'Effectuez des transactions DeFi avec des fonds virtuels, développez la meilleure stratégie!'
      },
      daoManager: {
        title: 'Gestionnaire DAO',
        description: 'Gérez votre DAO, développez la communauté, prenez les bonnes décisions!'
      }
    },

    dailyTasks: {
      title: 'Tâches quotidiennes',
      completeAll: 'Complétez toutes les tâches, gagnez un bonus!',
      completeAllBonus: 'Lorsque vous complétez toutes les tâches quotidiennes, vous recevrez un bonus supplémentaire de {coins} IDCOIN.',
      completeCryptoQuestLevels: 'Complétez 3 niveaux dans Crypto Quest',
      solveBlockchainPuzzle: 'Résolvez un puzzle dans Puzzle Blockchain',
      joinCryptoQuestTournament: 'Rejoignez le tournoi Crypto Quest',
      collectDailyIdcoin: 'Collectez votre récompense quotidienne IDCOIN',
      inviteFriend: 'Invitez un ami à GameHub'
    },

    tournament: {
      active: 'Tournoi actif',
      activeTournaments: 'Tournois actifs',
      ended: 'Terminé',
      daysHoursLeft: '{days} jours {hours} heures restantes',
      hoursMinutesLeft: '{hours} heures {minutes} minutes restantes',
      short: 'Tournoi',
      joinAndWin: 'Rejoignez le tournoi et courez la chance de gagner {coins} IDCOIN!',
      gameTournament: 'Tournoi {game}'
    },

    leaderboard: {
      yourRank: 'Votre classement',
      rankPosition: 'Rang {rank}',
      topPercentage: 'Vous êtes dans le top {percent}%!',
      weekly: 'Hebdomadaire',
      allTime: 'Tous les temps',
      seeFullList: 'Voir la liste complète',
      gameLeaderboards: 'Classements des jeux',
      you: 'Vous'
    },

    rewards: {
      balance: 'Solde',
      transfer: 'Transfert',
      transactions: 'Transactions',
      shop: 'Boutique de récompenses',
      cost: '{amount} IDCOIN',
      daily: 'Quotidien',
      completion: 'Achèvement',
      tournament: 'Tournoi',

      items: {
        premium: {
          title: 'Premium 1 mois',
          description: 'Expérience sans publicité et fonctionnalités supplémentaires'
        },
        nft: {
          title: 'Objet NFT',
          description: 'Avatars spéciaux et objets numériques'
        },
        xpBoost: {
          title: 'Boost XP',
          description: 'Points d\'expérience x2 pendant 3 jours'
        },
        cryptoGift: {
          title: 'Cadeau Crypto',
          description: 'Carte-cadeau de cryptomonnaie réelle'
        }
      }
    },

    achievements: {
      title: 'Réalisations',
      completed: 'Terminé',
      seeAll: 'Voir toutes les réalisations',

      firstGame: 'Premier jeu',
      firstGameDesc: 'Jouez à votre premier jeu',
      firstTournament: 'Premier tournoi',
      firstTournamentDesc: 'Rejoignez un tournoi',
      gameMaster: 'Maître du jeu',
      gameMasterDesc: 'Jouez à 5 jeux différents', collector: 'Collectionneur',
      collectorDesc: 'Gagnez 10 badges de réalisation'
    }
  },
  // IdentityCircle translations
  identityCircle: {
    title: 'IdentityCircle',
    subtitle: 'Votre couche sociale de confiance',
    visible: 'Visible',
    hidden: 'Caché',
    hide: 'Cacher',
    yourStory: 'Votre Histoire',
    invisibleMode: 'Mode Invisible Actif',
    invisibleDesc: 'Vous êtes complètement caché du cercle.',
    goVisible: 'Devenir Visible',
    createContent: 'Créer du Contenu',

    // Invisible mode enhancements
    invisible: {
      activated: 'Mode Invisible Activé',
      redirecting: 'Redirection vers le tableau de bord dans {seconds} secondes...',
      reactivate: 'Réactiver le Mode Invisible?',
      reactivateDesc: 'Vous étiez précédemment en mode invisible. Souhaitez-vous le réactiver?',
      yes: 'Oui, Devenir Invisible',
      no: 'Rester Visible',
      goingInvisible: 'Devenir invisible...',
      countdown: 'Redirection dans {count}...'
    },

    // Network view translations
    network: {
      title: 'Réseau de Pairs',
      viewMap: 'Voir le Réseau de Pairs',
      description: 'Explorez vos connexions dans une carte interactive',
      search: 'Rechercher des pairs...',
      stats: 'Statistiques du Réseau',
      total: 'Total des Pairs',
      online: 'En Ligne',
      close: 'Amis Proches',
      connected: 'Connecté',
      interactions: 'Interactions',
      trustScore: 'Score de Confiance',
      message: 'Message',
      filter: {
        all: 'Tous',
        online: 'En Ligne',
        close: 'Amis Proches'
      }
    },

    // Connections tab translations
    connections: {
      stats: 'Statistiques de Connexion',
      total: 'Connexions Totales',
      online: 'En Ligne Maintenant',
      recent: 'Connexions Récentes'
    }
  }
};